import React, { cloneElement, useMemo } from "react";
import PropTypes from "prop-types";
import rehypeReact from "rehype-react";

function useRehypeReact(components, createElement, Fragment) {
  function createHtmlAst() {
    return new rehypeReact({
      createElement,
      Fragment,
      components,
    }).Compiler;
  }
  return useMemo(createHtmlAst, [components, createElement, Fragment]);
}

/**
 * @module
 *
 * @desc Converts htmlAst data returned from Gatsby MarkdownRemark queries to
 *    react components based on element types
 *
 * @param {array} children - Child html content to convert to react components
 * @param {array} components - Components to be used for matched element types
 * @param {function} createElement - Function to use to create the react elements
 * @param {object} Fragment - Fragment to use instead of creating outer div
 *    containers
 * @param {string/number} id - ID to use for the component key
 */
export function RenderHtmlAst({
  components = {},
  createElement = React.createElement,
  htmlAst,
  Fragment = React.Fragment,
  id,
  ...rest
}) {
  const rehypeRenderAst = useRehypeReact(components, createElement, Fragment);

  const renderedNode = rehypeRenderAst(htmlAst);
  return cloneElement(renderedNode, rest);
}

RenderHtmlAst.propTypes = {
  components: PropTypes.object,
  createElement: PropTypes.func,
  Fragment: PropTypes.element,
  htmlAst: PropTypes.object,
};
